"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
var VideoPlayer = function (_a) {
    var videoUrl = _a.videoUrl, posterUrl = _a.posterUrl, props = __rest(_a, ["videoUrl", "posterUrl"]);
    var videoRef = react_1.default.useRef(null);
    var _b = __read(react_1.default.useState(true), 2), paused = _b[0], setPaused = _b[1];
    var _c = __read(react_1.default.useState(false), 2), mouseOver = _c[0], setMouseOver = _c[1];
    var _d = __read(react_1.default.useState(false), 2), videoLoaded = _d[0], setVideoLoaded = _d[1];
    react_1.default.useEffect(function () {
        var handleKeyDown = function (e) {
            if (e.key === 'Tab') {
                setMouseOver(true);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return function () {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    return (react_1.default.createElement(styles_1.VideoContainer, __assign({}, props, { onMouseOver: function () { return setMouseOver(true); }, onMouseLeave: function () { return setMouseOver(false); } }), videoUrl && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.Video, { onMouseDown: function (e) { return e.preventDefault(); }, onLoadedData: function () {
                setVideoLoaded(true);
            }, ref: videoRef, controls: videoLoaded && mouseOver ? true : false, onPlay: function () { return setPaused(false); }, onPause: function () { return setPaused(true); }, playsInline: true, poster: posterUrl, preload: "", controlsList: "nodownload", disablePictureInPicture: true, "data-testid": "video", "aria-label": paused
                ? "play ".concat(props['aria-label'], " video")
                : "pause ".concat(props['aria-label'], " video") },
            react_1.default.createElement("source", { src: videoUrl, type: "video/mp4", "data-testid": "video-source" })),
        paused && videoLoaded && (react_1.default.createElement(styles_1.Button, { onClick: function () { var _a; return (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.play(); }, tabIndex: -1, "aria-hidden": true },
            react_1.default.createElement(styles_1.StyledPlayIcon, null)))))));
};
exports.default = VideoPlayer;
//# sourceMappingURL=index.js.map